import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import CustomText from "components/base/CustomText";

interface ArgsType {
    vmNetworkId: string,
    vmNetworkName: string,
    vmNetworkDesc: string,
    externalYn: boolean,
    vmNetworkUpYn: boolean,
    vmNetworkPubType: string,
    projectName: string,

}

interface VmNetworkUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

VmNetworkUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VmNetworkUpdate(props:VmNetworkUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
        
    const [vmNetworkName, setVmNetworkName] = useState(props.args?.vmNetworkName || '');
    const [vmNetworkDesc, setVmNetworkDesc] = useState(props.args?.vmNetworkDesc || '');
    const [vmNetworkPubType, setVmNetworkPubType] = useState(props.args?.vmNetworkPubType || 'PUB');
    const [externalYn, setExternalYn] = useState(props.args?.externalYn|| false);
    const [vmNetworkUpYn, setVmNetworkUpYn] = useState(props.args?.vmNetworkUpYn|| false);    
    
    const [vmNetworkNameWarnYn, setVmNetworkNameWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkVmNetworkData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateVmNetwork();
        }
    }, [executeUpdateYn]);


    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function checkVmNetworkData() {
        setVmNetworkNameWarnYn(false);
        let message = "";
        let error = false;
        if(!vmNetworkName) {
            message = t("MESSAGE_VM_NETWORK_INFO_ENTER_ERROR_MESSAGE");
            setVmNetworkNameWarnYn(true);
            error = true;
        }
        if(error === true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }
        return !error;
    }
    function executeUpdateVmNetwork() {
        const updatePackageData = {
            network : {
                network_name: vmNetworkName,
                network_description: vmNetworkDesc,
                external_yn: externalYn,
                up_yn: vmNetworkUpYn
            }
        };
         
        requests.put(PLATFORM_URL.VM_NETWORK + '/' + props.args?.vmNetworkId, updatePackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_NETWORK_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_NETWORK_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    function selectButton(id, type){
        if(id === "ActiveNetwork") {
            if(type === 'Y') {
                setVmNetworkUpYn(true);
            } else {
                setVmNetworkUpYn(false);
            }
        } else if(id === "ExternalNetwork") {
            if(type === 'Y') {
                setExternalYn(true);
            } else {
                setExternalYn(false);
            }
        } else if(id === "NetworkShareType") {
            setVmNetworkPubType(type);
        }
        
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_NETWORK_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NETWORK_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={vmNetworkName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setVmNetworkName} 
                                warnYn={vmNetworkNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={vmNetworkDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setVmNetworkDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("EXTERNAL_NETWORK_CONNECT_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"ExternalNetwork"} 
                                type={"Y"} 
                                size={19} 
                                checked={externalYn} 
                                selectCb={selectButton} 
                                label={t("PUBLIC_TEXT")}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn 
                                id={"ExternalNetwork"} 
                                type={"N"} 
                                size={19} 
                                checked={!externalYn}
                                selectCb={selectButton} 
                                label={t("PRIVATE_TEXT")}
                                labelStyle={labelStyle}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("NETWORK_ACTIVE_STATE_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"ActiveNetwork"} 
                                type={"Y"} 
                                size={18} 
                                checked={vmNetworkUpYn} 
                                selectCb={selectButton} 
                                label={t("ACTIVE_TEXT")}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn 
                                id={"ActiveNetwork"} 
                                type={"N"} 
                                size={18} 
                                checked={!vmNetworkUpYn} 
                                selectCb={selectButton} 
                                label={t("INACTIVE_TEXT")}
                                labelStyle={labelStyle}
                            />
                        </View>
                        <Text style={style.rowDescribeContainer}>{t("MESSAGE_VM_NETWORK_CHANGE_STATE_WARN_MESSAGE")}</Text>
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SHARE_CATEGORY_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"NetworkShareType"}
                                type={"PUB"}
                                size={18}
                                activeYn={true}
                                checked={vmNetworkPubType === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            {
                                props.args?.vmNetworkPubType === "PRJ"
                                ? <CustomRadioBtn
                                id={"NetworkShareType"}
                                    type={"PRJ"}
                                    size={18}
                                    activeYn={true}
                                    checked={vmNetworkPubType === "PRJ" ? true: false}
                                    selectCb={selectButton}
                                    label={"개인(프로젝트)"}
                                    labelStyle={labelStyle}
                                />
                                : null
                            }
                            <View style={{width: 44}}/>
                            {
                                props.args?.vmNetworkPubType === "HDN"
                                ?
                                <CustomRadioBtn
                                    id={"NetworkShareType"}
                                    type={"HDN"}
                                    size={18}
                                    activeYn={false}
                                    checked={vmNetworkPubType === "HDN" ? true: false}
                                    selectCb={selectButton}
                                    label={"숨김(사용불가)"}
                                    labelStyle={labelStyle}
                                />
                                : null
                            }
                        </View>
                        {
                            props.args?.vmNetworkPubType === "PRJ" ?
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("PROJECT_INFO_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={112}
                                    width={300} height={36}
                                    value={props.args?.projectName}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(e) => {}}
                                    warnYn={false}
                                />
                            </View>
                            : null
                        }
                        {
                            props.args?.vmNetworkPubType !== "PUB"
                            ?<Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                                {t("MESSAGE_VM_NETWORK_SHARED_TYPE_CHANGE_DESCRIBE_MESSAGE")}
                            </Text>
                            : null
                        }
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}